import {Component, Input, OnInit} from "@angular/core";
import {NgForOf} from "@angular/common";
import {BillStatus} from "../../shipper";
import {arrayChunk} from "../misc";
import {SAStatusBadge} from "./isf.sa.status";


@Component({
	selector: "isf-bills",
	standalone: true,
	imports: [
		SAStatusBadge,
		NgForOf
	],
	template: `
        <table class="table table-sm mb-0 p-0">
            
            <tr *ngFor="let row of bills">
                <td *ngFor="let b of row" class="w-50">
                    
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <sa-status [status]="b.statusCode"></sa-status>
                        </div>
                        <div class="font-weight-bold" title="{{b.billType}}">{{ b.billNumber }}</div>
                    </div>
                    
                </td>
            </tr>
        
        </table>
        
        <!-- Popover template for full bl breakout-->
        <ng-template #blFull>
        
        </ng-template>
    `
})
export class ISFBills implements OnInit{
	
	bills:Array<Array<BillStatus>> = [];
	
	@Input()
	billData:string = "";
	
	
	ngOnInit(): void { this.parse(); }
	
	
	/**
	 *
	 */
	parse(){
		
		if(this.billData == null){return;}
		
		let bl:Array<BillStatus> = this.billData.split("|")
			.map((d) => d.split(":"))
			.map((d) => <BillStatus><unknown>({
				billType: d[0],
				billNumber: d[1],
				statusCode: d[2] || null
			}))
		;
		
		this.bills = arrayChunk(bl,2);
	}
}
